import { TimeFormat } from '@chronosphereio/core';
import { useVizFrameworkConfig } from '../model/config';

/**
 * Returns the user's time format preference (12 or 24 hour time).
 * This value is stored in the UserTimePreferencesProvider in cloud
 * and is passed to viz framework via the VizFrameworkConfigProvider.
 * If the timeFormat can't be retrieved from config, it falls back to '24h'.
 */
export const useUserTimeFormat = (): TimeFormat => {
  // fall back to 24 hour time if we can't get the actual value from viz framework config
  const timeFormat = useVizFrameworkConfig()?.timeFormat || '24h';
  return timeFormat;
};
